import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth, postDataWAuth, deleteDataWAuth } from "../../../utils/api-service";
import { NOTIFICATION_API } from "../../../constants/constant";

export const fetchNotifications = createAsyncThunk(
  "notification/fetchNotifications",
  async () => {
    const response = await getDataWAuth(NOTIFICATION_API);
    return response.data;
  }
);

export const createNotification = createAsyncThunk(
  "notification/createNotification",
  async (text) => {
    const response = await postDataWAuth(NOTIFICATION_API, { text });
    return response.data;
  }
);

export const removeNotification = createAsyncThunk(
  "notification/removeNotification",
  async (id) => {
    await deleteDataWAuth(`${NOTIFICATION_API}/${id}`);
    return id;
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    notifications: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.notifications = action.payload;
        state.loading = false;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.notifications.unshift(action.payload);
      })
      .addCase(removeNotification.fulfilled, (state, action) => {
        state.notifications = state.notifications.filter(
          (notification) => notification.id !== action.payload
        );
      });
  },
});

export default notificationSlice.reducer;
